import React from 'react';
import { useNavigate } from 'react-router-dom';
import BusinessForm from '../../components/BusinessForm';
import { api } from '../../lib/api';

export default function OwnerAddBusiness() {
  const nav = useNavigate();
  const onSubmit = async (payload) => {
    const { data } = await api.post('/owner/businesses', payload);
    nav('/owner/businesses' + (data?.id ? `/${data.id}` : ''));
  };
  return (
    <div data-testid="owner-add">
      <h2 className="mb-3">Add business</h2>
      <div className="ap-card"><BusinessForm onSubmit={onSubmit} submitLabel="Create business" /></div>
      <p className="small text-muted-2 mt-2">Newly created businesses are marked as <strong>Pending</strong> and go live once approved by an admin.</p>
    </div>
  );
}
